import React, { useRef,useEffect } from 'react'
import PhilosophyImg1 from '../../assets/images/philosophy-1.jpg';
import PhilosophyImg2 from '../../assets/images/philosophy-2.jpg';
import { taxtReveal } from '../../utils/gsapService';
import {ScrollTrigger, gsap} from 'gsap/all';
gsap.registerPlugin(ScrollTrigger); 

export default function PhilosophyAbout() {

  const headingLine = useRef(null);
  const desLine = useRef(null); 

  useEffect(() => { 

    let textRevealTl = null;
    const aniStart = setTimeout(()=>{ 
      textRevealTl = taxtReveal([headingLine.current, desLine.current], headingLine.current);
      ScrollTrigger.refresh();
    }, 2000); 
    ScrollTrigger.refresh();  
    return () => {
      if(textRevealTl != null){ 
        textRevealTl.tl.kill();
        textRevealTl.Lines.revert();  
      }
      clearTimeout(aniStart);
    };
  }, []); 

  return (
    <section className="pa-section bg-body">
      <h2 className="title-xxl">Philosophy</h2>
      <div className="container">
        <div className="row">
          <div className="col-lg-5"> 
            <div className="img-wrap">
              <img src={PhilosophyImg1} alt="" />
              <img src={PhilosophyImg2} className="img-2" alt="" />
            </div>
          </div>
          <div className="col-lg-7"> 
            <div className="text-content text-content-wrap ps-xl-5">
              <h2 className="title-md" ref={headingLine}>Founder’s Vision</h2>
              <p className="des max-w500" ref={desLine}>As a former French (Burgundy) winemaker, Ray's vision is to focus on unique details while pushing the boundaries of each expression. We are looking to share singular experiences from each and every barrel. On the X-Series side, this is our chance to truly disrupt the industry and to move the needle forward.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
